<template>
  <div class="menu-group">
    <div class="group-title" :class="isActive('url')" @click="getChildren(item, 'MOUSE_CLICK')" @mouseenter="getChildren(item, 'MOUSE_SLIDING')">
      <!--      展开时展示内容-->
      <template v-if="sidebarOpened">
        <img v-if="item.icon" :src="item.icon" alt="" />
        <span>{{ item.name }}</span>
        <i v-if="item.list" class="el-icon-arrow-right" :class="{ rotated: isSubMenuOpen }"></i>
      </template>
      <!--      收起时展示内容-->
      <template v-else>
        <img v-if="item.icon" style="margin-bottom: 8px; margin-top: 8px" :src="item.icon" alt="" />
        <span style="min-width: 50px; text-align: center; font-size: 12px">{{ item.abbrName }}</span>
      </template>
    </div>
    <div v-if="secondMenu.length > 0 && nowSys === item.name" class="second-menu2" :style="{ left: sidebarOpened ? '200px' : '54px' }">
      <div style="display: flex">
        <!--    根据just-show-header 只显示头    -->
        <div v-for="secondeItem in secondMenu" :key="secondeItem.name" style="margin-right: 20px; margin-top: 40px">
          <second-index
            :key="secondeItem.id"
            :item="secondeItem"
            :sys-belong="secondeItem.url"
            :menu-top-displayed="menuTopDisplayed"
            :menu-pop-up-method="menuPopUpMethod"
            :just-show-header="true"
            @item-click="itemClick"
          ></second-index>
        </div>
      </div>
      <div style="display: flex; overflow-y: scroll; height: calc(100vh - 130px)">
        <!--    根据just-show-header 只显示头下面的内容    -->
        <div v-for="secondeItem in secondMenu" :key="secondeItem.name" style="margin-right: 20px">
          <second-index
            :key="secondeItem.id"
            :item="secondeItem"
            :sys-belong="secondeItem.url"
            :menu-top-displayed="menuTopDisplayed"
            :menu-pop-up-method="menuPopUpMethod"
            :just-show-header="false"
            @item-click="itemClick"
          ></second-index>
        </div>
      </div>
    </div>
    <!--    假遮罩，用来进行关闭二级菜单，主要用于主内容是iframe时，无法通过dom点击来关闭的情况-->
    <div v-if="secondMenu.length > 0 && nowSys === item.name" class="second-menu2_bg" @click="hideMenu"></div>
  </div>
</template>

<script>
import SecondIndex from "@/layout/components/NewSiderSecond/SidebarItem/second-index.vue"
import { mapActions, mapState } from "vuex"
import { userCollectMenu, userCollectMenuDel } from "@/api/user"
import { translateDataToTree, treeToArray } from "@/utils"
export default {
  name: "SidebarItem",
  components: { SecondIndex },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    level: {
      type: Number,
      default: 0
    },
    menuPopUpMethod: {
      type: String,
      default: "MOUSE_CLICK"
    },
    menuTopDisplayed: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      secondMenu: [],
      isSubMenuOpen: false
    }
  },
  computed: {
    sidebarOpened() {
      return this.$store.state.app.sidebar.opened
    },
    sidebarFakeClick() {
      return this.$store.state.app.sidebar.fakeClick
    },
    ...mapState("user", ["favoriteMenus", "nowSys"])
  },
  watch: {
    sidebarOpened: {
      handler(n) {
        this.isSubMenuOpen = false
        if (n) {
          // 展开时，默认展开选中的菜单
          const listUrlArr = this.item.list.map(item => item.url)
          if (listUrlArr.includes(this.$route.fullPath.split("#")[0])) {
            this.isSubMenuOpen = true
          }
        }
      },
      immediate: true
    }
  },
  created() {
    // 接收通知，清空secondMenu,减轻dom负担
    this.$bus.$on("clearSecondMenu", item => {
      this.secondMenu = []
    })
  },
  beforeDestroy() {
    this.$bus.$off("clearSecondMenu")
  },
  methods: {
    ...mapActions("user", ["getFavorite"]),
    // 返回收藏菜单id集合
    favoriteMenusIds() {
      return this.favoriteMenus.map(item => item.id)
    },
    // 收藏菜单
    favoriteIt(item) {
      userCollectMenu({ menuId: item.id }).then(res => {
        // 重新获取收藏菜单
        this.getFavorite()
      })
    },
    // 取消收藏
    cancelFavoriteIt(item) {
      userCollectMenuDel({ menuId: item.id }).then(res => {
        // 重新获取收藏菜单
        this.getFavorite()
      })
    },
    // 匹配激活
    isActive(url) {
      // 业务域选中状态
      const listUrlArr = this.item.list.map(item => item.url)
      // 解决订单中心归属在cdp里，但是不高亮的问题
      if (this.item.list) {
        this.item.list.forEach(item => {
          if (item.list) {
            item.list.forEach(kItem => {
              listUrlArr.push(kItem.url)
            })
          }
        })
      }
      if (!this.sidebarOpened && listUrlArr.includes(this.$route.fullPath.split("#")[0])) {
        return "active"
      }
      // 目录菜单(要判断一下系统管理和权限管理，统一项目，但是目录不是同一个，所以需要单端判断)
      if (this.$route.fullPath.split("#")[0] === "/masterData" && this.item.name === "MDM") {
        return "active"
      }
      return ""
    },
    // 获取下一级菜单
    getChildren(item, menuPopUpMethod) {
      if (this.menuPopUpMethod !== menuPopUpMethod) return
      // 通知其他组件，清空secondMenu数组
      this.$bus.$emit("clearSecondMenu")

      // 处理数据
      if (item.id === -999) {
        // 收藏
        this.secondMenu = [{ isFavMenu: true }]
      } else {
        if (item.backData) {
          // 备份数据，保证内存问题
          this.secondMenu = item.backData
        } else {
          let menuList = treeToArray(item.list)
          for (let i = 0; i < menuList.length; i++) {
            const menuListItem = menuList[i]
            menuListItem.bfList = menuListItem.list
            menuListItem.list = []
            menuListItem.children = []
            if (menuListItem.type != 1) {
              menuList.splice(i, 1)
              i--
            }
          }
          menuList = translateDataToTree(menuList, item.id)
          // // 重新赋值
          this.secondMenu = menuList
          // 备份数据，保证内存问题
          item.backData = menuList
        }
      }
      this.$store.commit("user/SET_NOWSYS", item.name)
    },
    // 点击菜单
    itemClick(item) {
      // 判断，当前Url下面，是否有相对应的页面，如果没有，则提示不允许进入
      let havePage = false
      if (item.bfList && item.bfList.length > 0) {
        item.bfList.forEach(bfItem => {
          if (bfItem.type === 2 && item.url === bfItem.url) {
            // 并且当前名字，改为页面的名字
            if (!item.meta) {
              item.meta = {
                title: bfItem.name
              }
            } else {
              item.meta.title = bfItem.name
            }
            havePage = true
          }
        })
        if (!havePage) {
          this.$message.warning("请先设置当前菜单下的页面！")
          return
        }
      } else {
        if (!havePage) {
          this.$message.warning("请先设置当前菜单下的页面！")
          return
        }
      }
      item.fullPath = this.resolvePath(item.url)
      if (!item.meta) {
        item.meta = {
          title: item.name
        }
      }
      this.$router.push({ path: item.fullPath })
      this.$store.dispatch("tagsView/addView", item)
      // 重制nowSys,让二层菜单隐藏
      this.$store.commit("user/SET_NOWSYS", "")
      // 判断是否是收缩时，点击弹起的，如果是，则再次收缩
      if (this.sidebarFakeClick) {
        this.$store.dispatch("app/toggleSideBar")
      }
    },
    resolvePath(routePath) {
      // 帆软报表暂时处理，后期需要统一在数据中心，进行页面前置
      if (routePath === "https://fr.osa.com/webroot/decision/view/report?viewlet=/流程与IT/帆软广告回本报表.cpt") {
        return "/count#/count/fanruan"
      }
      if (routePath === "https://fr.osa.com/webroot/decision/view/form?viewlet=WCT/数据中心/AB客_裂变销售报表.frm") {
        return "/count#/count/fanruanAB"
      }
      // //权限中心比较特殊，没有作为一个中心上传git，而是和主数据合在一起，所以需要单独判断下
      const isAuthorityCenter = routePath.split("/")?.[1] === "authorityCenter"
      if (isAuthorityCenter) {
        return "/masterData" + "#" + routePath
      } else {
        return "/" + routePath.split("/")[1] + "#" + routePath
      }
    },
    hideMenu() {
      this.$store.commit("user/SET_NOWSYS", "")
    }
  }
}
</script>
<style scoped lang="scss">
.menu-group .group-title {
  background-color: #132547; /* 组标题背景色 */
  width: 54px;
  height: 54px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s ease; /* 组标题背景色过渡 */
  overflow: hidden;
}

.menu-group .group-title:hover {
  background-color: #2f497b; /* 组标题悬停背景色 */
}

.menu-group .group-title i {
  margin-right: 10px;
}
.menu-group img {
  width: 16px;
  height: 16px;
}
.menu-group .group-title span {
  flex: 1;
  flex-shrink: 0;
}

.menu-group .group-title .el-icon-arrow-down {
  transition: transform 0.3s ease; /* 箭头旋转过渡 */
}

.menu-group .group-title .rotated {
  transform: rotate(180deg); /* 旋转箭头 */
}

.menu-group ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-group li {
  padding: 10px 20px;
}

.menu-group a {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #ffffff;
  transition: color 0.3s ease; /* 链接颜色过渡 */
}

.menu-group a:hover {
  color: #dcddde; /* 链接悬停颜色 */
}

.menu-group a i {
  margin-right: 10px;
}

.collapsed .menu-group span,
.collapsed .menu-group .group-title span {
  display: none;
}
.group-children {
  background: #051432;
  li {
    cursor: pointer;
    padding: 15px 30px 15px 40px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  li:hover {
    background: #1e3052;
  }
  li:hover .second-menu {
    display: block;
  }
}
/* 过渡动画 */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
  overflow: hidden; /* 防止展开时内容溢出 */
  max-height: 300px; /* 设置最大高度，防止展开过快 */
}
.slide-fade-enter,
.slide-fade-leave-to {
  max-height: 0;
  opacity: 0;
}
.second-menu {
  position: absolute;
  left: 200px;
  top: 0;
  width: 210px;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #1d325b;
  display: none;

  /* 改造滚动条-适用于google内核 */

  ::-webkit-scrollbar {
    /* 控制竖向滚动条的宽度 */
    width: 3px;
    /* 控制横向滚动条的高度 */
    height: 3px;
    background-color: #fff;
  }
  ::-webkit-scrollbar-thumb {
    /* box-shadow: inset 0 0 6px rgba(0, 0, 0, .3); */
    background-color: rgba(144, 147, 153, 0.3);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-track {
    /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
    border-radius: 3px;
    background: rgba(255, 255, 255, 1);
  }
}
.icon-fav,
.icon-favoured {
  font-size: 12px;
  color: #faad14;
}
.active {
  background-color: #3296fa !important;
}
.second-menu2 {
  display: flex;
  flex-direction: column;
  position: absolute;
  min-width: 250px;
  flex-shrink: 0;
  height: 100vh;
  //overflow-y: scroll;
  background: #ffffff;
  color: #333333;
  left: 200px;
  top: 0;
  padding: 20px;
  z-index: 2001;
  -moz-box-shadow: 2px 2px 5px #f3f3f3;
  -webkit-box-shadow: 2px 2px 5px #f3f3f3;
  box-shadow: 2px 2px 5px #f3f3f3;
}
.second-menu2_bg {
  position: fixed;
  width: calc(100vw - 54px);
  height: 100vh;
  z-index: 2000;
  left: 54px;
  top: 0px;
  opacity: 0;
}
</style>
